<script lang="ts">
  import Router, { replace } from 'svelte-spa-router';
  import { onMount } from 'svelte';
  import ReportSidebar from '../report/ReportSidebar.svelte';
  import Header from '../Header.svelte';
  import { report, wrapProgress } from '../../store';
  import { createRoutesWithPrefix } from '../../router/router.helpers';
  import ReportCategory from '../report/ReportCategory.svelte';
  import { ProjectConfigService, ReportService } from '../../modules';
  import type { Report } from '../../modules/report/report.interface';
  import { StatusCode, UiError } from '../../lib/errors';
  import { iframeStatus } from '../../modules/report/report.store';
  import config from '../../config';

  export let params: { project: string; reportDate: string; wild: string };
  let previewUrl = `${config('PREVIEW_URL')}?preview=${params.reportDate}`;

  const routes = createRoutesWithPrefix('/report/:project/:reportDate', {
    '/:category': ReportCategory,
  });
  const projectConfig = ProjectConfigService.get(params.project);
  let currentReport: Report;

  onMount(onMounted);

  async function onMounted() {
    try {
      await fetchReport();
      fetchItemCounts();
    } catch (e) {}
  }

  async function fetchReport() {
    return wrapProgress(async () => {
      try {
        currentReport = await ReportService.get(params.project, params.reportDate);
      } catch (error) {
        if (error instanceof UiError && error.code === StatusCode.NOT_FOUND) {
          error.message = `Report for ${params.reportDate} not found!`;
          await replace(`/project/${params.project}/reports`);

          throw error;
        }
      }

      report.setActiveReport({
        project: currentReport.project,
        date: currentReport.date,
        datePublished: currentReport.datePublished,
        dateScheduled: currentReport.dateScheduled,
        itemCounts: {},
      });
    }, true)();
  }

  async function fetchItemCounts() {
    if (!params.wild) {
      navigateFirstCategory();
    }

    await ReportService.getItemCounts($report.project, $report.date);
  }

  function navigateFirstCategory() {
    const firstCategoryKey = projectConfig.categories[0].key;
    const { project, reportDate } = params;

    replace(`/report/${project}/${reportDate}/${firstCategoryKey}`);
  }
</script>

<Header
  title={projectConfig.name}
  titleLink="/project/{projectConfig.key}"
  subtitle={params.reportDate}
  on:click={() => iframeStatus.set(false)}
/>
{#if currentReport}
  <ReportSidebar activeCategory={params.wild} on:click={() => iframeStatus.set(false)} />
  {#if $iframeStatus}
    <iframe
      id="frame"
      width="100%"
      height="100%"
      title={projectConfig.name}
      src={previewUrl}
    />
  {:else}
    <div class="page">
      <Router {routes} />
    </div>
  {/if}
{/if}

<style lang="scss">
  #frame {
    margin-top: 40px;
    margin-left: 140px;
  }
</style>
